import { logCustomDatadogAction } from "../scripts/shared_setup"
import detectPlatform from "shared/detect_platform"

export default async function ProsumerHome(opts = {}) {
  const hero = document.querySelector("[data-hero-section]")

  if (hero) {
    logCustomDatadogAction("header_impression", { platform: detectPlatform() })

    // The collages run on the compositor, but their ~230 CSS animations still tick. They start
    // once the page has loaded (a 240s turn makes the wait invisible) and pause off screen.
    const startAnimations = () => hero.classList.add("is-animating")
    if (document.readyState === "complete") {
      startAnimations()
    } else {
      window.addEventListener("load", startAnimations, { once: true })
    }
    new IntersectionObserver(([entry]) => hero.classList.toggle("is-offscreen", !entry.isIntersecting)).observe(hero)
  }

  const ctaButton = document.querySelector("[data-cta-text]")
  if (ctaButton) {
    ctaButton.addEventListener("click", () => {
      logCustomDatadogAction("header_cta_clicked", {
        cta_text: ctaButton.dataset.ctaText,
        platform: detectPlatform(),
      })
    })
  }

  // Plan type toggle
  const planToggle = document.querySelector(".toggle")
  const prices = opts.prices
  const urls = opts.urls
  planToggle?.addEventListener("click", function (e) {
    e.preventDefault()
    this.classList.toggle("active")

    const proPlanLinks = document.querySelectorAll("a[data-plan-page='true']")
    const proPriceDisplay = document.querySelector(".pro-plus.price-amount")
    const proYearlyPriceDisplay = document.querySelector(".pro-plus.yearly-price")

    const intermediatePlanLinks = document.querySelectorAll("a[data-intermediate-plan-page='true']")
    const intermediatePriceDisplay = document.querySelector(".intermediate-pro.price-amount")
    const intermediateYearlyPriceDisplay = document.querySelector(".intermediate-pro.yearly-price")

    const interval = this.classList.contains("active") ? "yearly" : "monthly"

    proPlanLinks.forEach(link => {
      link.setAttribute("href", urls.pro_plus[interval])
    })
    proPriceDisplay.innerHTML = prices.pro_plus[interval]
    intermediatePlanLinks.forEach(link => {
      link.setAttribute("href", urls.intermediate_pro[interval])
    })

    intermediatePriceDisplay.innerHTML = prices.intermediate_pro[interval]

    proYearlyPriceDisplay.classList.toggle("hidden")
    intermediateYearlyPriceDisplay.classList.toggle("hidden")
    document.querySelectorAll(".yearly-price-spacer").forEach(el => {
      el.classList.toggle("hidden")
    })
  })
}
